import { DashboardService } from "./../../../dashboard.service";
import {
  Component,
  PACKAGE_ROOT_URL,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../accountant.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
} from "@angular/forms";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";

import { Subject } from "rxjs";
import { FilesManagerService } from "src/app/dashboard/files-manager/files-manager.service";
import { RootFolders } from "src/app/dashboard/files-manager/types";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { ActiveClientsOnlyPipe } from "../../common/active-clients-only.pipe";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { NgFor, NgIf, NgClass, I18nPluralPipe } from "@angular/common";

/* This is a component which we pass in modal*/
@Component({
  selector: "app-modal-move-file",
  templateUrl: "./move-file-modal.component.html",
  styleUrls: ["../../../files-manager/files-manager.component.scss"],
  imports: [
    NgFor,
    NgIf,
    FormsModule,
    TypeaheadModule,
    NgClass,
    I18nPluralPipe,
    ActiveClientsOnlyPipe,
  ],
})
export class MoveFileModalComponent implements OnInit {
  @Input() currentConversationID: number;
  @Input() fileDetails: { etag: string; filename: string };
  @Input() folderDetails: { uuid: string; folder_name: string };
  @Input() cutOrCopyAction: boolean = false;
  @Input() receiveFilesFromClientTask: boolean = false;
  @Input() showWorkspaceSelector: boolean = false;
  @Input() availableWorkspaces: any[] = [];
  @Input() selectedFolders: any[] = [];
  public onClose: Subject<any>;

  currentFolder: any = [];
  breadcrumbs = {
    folders: [
      {
        name: "Home", // name of the folder
        uuid: "", // id of the folder - used to fetch its info again when needed
        data: [], // exactly same data as currentFolder (and previousFolder)
      },
    ],
  };
  isHome = true;

  filePluralMapping = {
    "=0": "No files",
    "=1": "1 file",
    other: "# files",
  };

  folderPluralMapping = {
    "=0": "No folders",
    "=1": "1 folder",
    other: "# folders",
  };

  displayName: string;

  selectedFolderIndex = 0;
  selectedFolder = {
    name: "",
    uuid: "",
  };

  fileCounters = {
    all: 0,
    staff: 0,
  };

  selectedWorkspaceObj: any = null;
  selectedWorkspace: string = "";

  isLoading: boolean = false;
  // New folder creation properties
  isCreatingFolder = false;
  newFolderName = "";
  @ViewChild("newFolderInput") newFolderInput: ElementRef;

  constructor(
    public bsModalRef: BsModalRef,
    private toastr: HotToastService,
    private filesManagerService: FilesManagerService,
    public dashboardStore: DashboardStore,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();

    if (this.showWorkspaceSelector) {
      if (this.availableWorkspaces.length >= 1) {
        console.log("availableWorkspace >= 1", this.availableWorkspaces);

        this.selectedWorkspaceObj = this.availableWorkspaces[0];
        this.selectedWorkspace = this.selectedWorkspaceObj["name"];
        this.currentConversationID =
          this.selectedWorkspaceObj["company_conversation"].id;
      }

      if (this.availableWorkspaces.length == 0) {
        this.availableWorkspaces = this.dashboardStore.clients;
      }
    }

    if (this.currentConversationID != null) {
      this.getFileCounters();
    }
  }

  // DISPLAY

  getFileCounters() {
    this.getFileCount("all");
    this.getFileCount("staff");
  }

  async getFileCount(type) {
    await this.filesManagerService
      .getFileCount(this.currentConversationID, type)
      .then((res: any) => {
        const data = res;
        this.fileCounters[type] = data.count;
        this.cdr.detectChanges();
      });
  }

  // NAVIGATE

  appendBreadcrumb(name, uuid, data) {
    // add entry to breadcrumbs
    this.breadcrumbs.folders.push({ name, uuid, data });
  }

  removeFromBreadcrumbs(pos) {
    // discards all entries from array past given position
    this.breadcrumbs.folders.length = pos;
  }

  getClientShared() {
    // fetches all folders and files staff_only = False
    // and without parent folder (root level)
    this.isHome = false;
    this.filesManagerService
      .getAll(this.currentConversationID)
      .then((res: any) => {
        const data = res;
        this.currentFolder = data;
        this.appendBreadcrumb(data.title, "client", data);
      });
  }

  getStaffOnly() {
    // fetches folders that have staff_only = True
    this.isHome = false;
    this.filesManagerService
      .getStaffOnly(this.currentConversationID)
      .then((res: any) => {
        const data = res;
        this.currentFolder = data;
        this.appendBreadcrumb(data.title, "staff", data);
      });
  }

  reopenFolder(pos) {
    // reopens a folder already fetched from backend
    this.removeFromBreadcrumbs(pos + 1);
    this.currentFolder = this.breadcrumbs.folders[pos].data;
    if (pos === 0) {
      console.log("back to home. show default folders");
      this.isHome = true;
      this.currentFolder = [];
    }
  }

  viewFolder(folder_uuid: string) {
    // if (this.folderDetails && folder_uuid === this.folderDetails.uuid) {
    //   console.log("invalid movement. you cant view the current folder");
    //   return;
    // }

    this.isHome = false;
    this.selectedFolderIndex = 0;
    this.filesManagerService
      .getFolder(this.currentConversationID, folder_uuid)
      .then((res: any) => {
        const data = res;
        if (
          this.breadcrumbs.folders[this.breadcrumbs.folders.length - 1].uuid ===
          folder_uuid
        ) {
          this.breadcrumbs.folders.pop();
        }
        this.breadcrumbs.folders.push({
          name: data.title,
          uuid: folder_uuid,
          data,
        });
        this.currentFolder = data;
      });
  }

  selectFolder(name: string, uuid: string, highlight: number) {
    // set the folder as selected.
    // if user confirms, file will be moved to this folder

    if (this.folderDetails && uuid === this.folderDetails.uuid) {
      console.log(
        "invalid movement. you cant select the current folder as destination",
      );
      return;
    }

    this.selectedFolder.name = name;
    this.selectedFolder.uuid = uuid;
    if (uuid === "client") {
      this.selectedFolderIndex = 1;
    } else if (uuid === "staff") {
      this.selectedFolderIndex = 2;
    } else {
      this.selectedFolderIndex = highlight;
    }
  }

  cancel() {
    this.onClose.next(false);
  }

  confirm() {
    if (this.receiveFilesFromClientTask) {
      if (
        this.selectedFolder.uuid === RootFolders.ROOT_CLIENT_SHARED ||
        this.selectedFolder.uuid === RootFolders.ROOT_STAFF_ONLY
      ) {
        this.toastr.error(
          "You can't select a root level folder for this action. Please, choose a child folder.",
        );
        return;
      }
    }

    this.isLoading = true;
    this.onClose.next({
      target_uuid: this.selectedFolder.uuid,
      selectedWorkspace: this.selectedWorkspaceObj,
    });
  }

  selectWorkspace(event) {
    this.selectedFolderIndex = 0;
    this.selectedFolder = {
      name: "",
      uuid: "",
    };

    this.fileCounters = {
      all: 0,
      staff: 0,
    };

    this.breadcrumbs = {
      folders: [
        {
          name: "Home",
          uuid: "",
          data: [],
        },
      ],
    };
    this.isHome = true;
    this.currentFolder = [];

    this.selectedWorkspaceObj = event.item;
    this.selectedWorkspace = event.value;

    this.currentConversationID =
      this.selectedWorkspaceObj["company_conversation"].id;

    this.getFileCounters();
  }

  startCreatingFolder() {
    this.isCreatingFolder = true;
    this.newFolderName = "";
    // Focus the input after it's rendered
    setTimeout(() => {
      this.newFolderInput?.nativeElement?.focus();
    });
  }

  createFolder() {
    if (!this.newFolderName?.trim()) {
      this.isCreatingFolder = false;
      return;
    }

    const parentUUID = this.isHome ? "client" : this.currentFolder.uuid;
    const isStaffOnly = this.selectedFolderIndex === 2; // If staff folder is selected

    this.filesManagerService
      .createFolder(
        this.currentConversationID,
        parentUUID,
        this.newFolderName.trim(),
        isStaffOnly,
      )
      .then(
        (result) => {
          this.toastr.success("Folder created successfully.");
          this.isCreatingFolder = false;

          // Create a new folder object with the response data
          const newFolder = {
            name: this.newFolderName.trim(),
            uuid: result.folder_uuid,
            file_count: 0,
          };

          // Add the new folder to the beginning of the folders array
          if (this.currentFolder.folders) {
            this.currentFolder.folders.unshift(newFolder);
          } else {
            this.currentFolder.folders = [newFolder];
          }

          // Select the newly created folder
          this.selectFolder(newFolder.name, newFolder.uuid, 3); // 3 is the index after Create Folder button

          this.newFolderName = "";
          this.cdr.detectChanges();
        },
        (error) => {
          console.error("Failed to create folder:", error);
          this.toastr.error("Something went wrong when creating the folder.");
          this.isCreatingFolder = false;
        },
      );
  }
}
